// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-screen--container {
  position: absolute;
  width: auto;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 9999;
}

.loading-screen--spinner {
  content: "";
  display: block;
  position: absolute;
  left: 48%;
  top: 40%;
  width: 63px;
  height: 63px;
  margin: 0 auto;
  border: 4px solid #fff;
  border-radius: 50%;
  border-left-color: transparent;
  border-right-color: transparent;
  animation: loading-screen-spin 500ms infinite linear;
  -o-animation: loading-screen-spin 500ms infinite linear;
  -ms-animation: loading-screen-spin 500ms infinite linear;
  -webkit-animation: loading-screen-spin 500ms infinite linear;
  -moz-animation: loading-screen-spin 500ms infinite linear;
}

@keyframes loading-screen-spin {
  100% {
    transform: rotate(360deg);
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/main/apps/components/loading-screen/loading-screen.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,0CAAA;EACA,aAAA;AACJ;;AAEA;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;EACA,kBAAA;EACA,8BAAA;EACA,+BAAA;EACA,oDAAA;EACA,uDAAA;EACA,wDAAA;EACA,4DAAA;EACA,yDAAA;AACJ;;AAEA;EACI;IACI,yBAAA;IACA,yBAAA;EACN;AACF","sourcesContent":[".loading-screen--container {\n    position: absolute;\n    width: auto;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    background-color: rgba(255, 255, 255, 0.7);\n    z-index: 9999;\n}\n\n.loading-screen--spinner {\n    content: \"\";\n    display: block;\n    position: absolute;\n    left: 48%;\n    top: 40%;\n    width: 63px;\n    height: 63px;\n    margin: 0 auto;\n    border: 4px solid #fff;\n    border-radius: 50%;\n    border-left-color: transparent;\n    border-right-color: transparent;\n    animation: loading-screen-spin 500ms infinite linear;\n    -o-animation: loading-screen-spin 500ms infinite linear;\n    -ms-animation: loading-screen-spin 500ms infinite linear;\n    -webkit-animation: loading-screen-spin 500ms infinite linear;\n    -moz-animation: loading-screen-spin 500ms infinite linear;\n}\n\n@keyframes loading-screen-spin {\n    100% {\n        transform: rotate(360deg);\n        transform: rotate(360deg);\n    }\n}\n\n@-o-keyframes loading-screen-spin {\n    100% {\n        -o-transform: rotate(360deg);\n        transform: rotate(360deg);\n    }\n}\n\n@-ms-keyframes loading-screen-spin {\n    100% {\n        -ms-transform: rotate(360deg);\n        transform: rotate(360deg);\n    }\n}\n\n@-webkit-keyframes loading-screen-spin {\n    100% {\n        -webkit-transform: rotate(360deg);\n        transform: rotate(360deg);\n    }\n}\n\n@-moz-keyframes loading-screen-spin {\n    100% {\n        -moz-transform: rotate(360deg);\n        transform: rotate(360deg);\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
